import React from "react";
import makeStyles from "@mui/styles/makeStyles";

import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import PanelLoadingIndicator from "../../components/PanelLoadingIndicator";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";

const useStyles = makeStyles(theme => ({
  root: {
    padding: "0",
  },

  close: {
    width: "40px",
    height: "40px",
    position: "relative",
    right: "-10px",
  },

  title: {
    textAlign: "left",
    color: theme.palette.brandPrimary,
    lineHeight: "4rem",
  },

  label: {
    fontStyle: "normal",
    fontSize: "1.6rem",
  },

  loadingIndicator: {
    position: "absolute",
    height: "100%",
    width: "100%",
    backgroundColor: theme.palette.secondary.dark,
  },
}));

const MediaDialog = props => {
  const {
    open,
    title,
    content,
    actions,
    loading,
    handleClose,
    titleClassName,
    contentClassName,
    actionsClassName,
    fullScreen,
    fullWidth,
    maxWidth,
  } = props;
  const classes = useStyles();
  return (
    <Dialog
      open={open}
      fullScreen={fullScreen}
      fullWidth={fullWidth}
      maxWidth={maxWidth}
    >
      {loading && (
        <div className={classes.loadingIndicator}>
          <PanelLoadingIndicator />
        </div>
      )}
      <DialogTitle>
        <Grid container justifyContent="space-between" alignItems="center">
          <Typography
            variant="h4"
            classes={{ root: titleClassName || classes.title }}
          >
            {title}
          </Typography>
          <IconButton
            classes={{ root: classes.close }}
            onClick={handleClose}
            size="large"
          >
            <CloseIcon fontSize="large" />
          </IconButton>
        </Grid>
      </DialogTitle>
      <DialogContent classes={{ root: contentClassName || classes.content }}>
        {content}
      </DialogContent>
      <DialogActions classes={{ root: actionsClassName || classes.actions }}>
        {actions}
      </DialogActions>
    </Dialog>
  );
};

export default MediaDialog;
